import React from "react";
import { Badge, BadgeProps } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { TIRE_SET_STATUS_MAP } from "@/config/tireOptions";

import { AppIcon } from "@/components/generic/AppIcon";

// ============================================
// Types
// ============================================

export interface TireSetStatusBadgeProps extends Omit<BadgeProps, "color" | "children"> {
  /** Tire set status value from the database */
  value: number | null | undefined;

  /** Whether to show the icon */
  showIcon?: boolean;
}

// ============================================
// Component
// ============================================

export const TireSetStatusBadge: React.FC<TireSetStatusBadgeProps> = ({
  value,
  showIcon = true,
  size = "sm",
  variant = "light",
  ...rest
}) => {
  const { t } = useTranslation(["tireSets"]);

  const option = value ? TIRE_SET_STATUS_MAP[value] : undefined;

  if (!option) return null;

  return (
    <Badge
      color={option.color}
      variant={variant}
      size={size}
      leftSection={
        showIcon ? <AppIcon iconName={option.icon || ''} size={12} /> : undefined
      }
      {...rest}
    >
      {t(`tireSets:${option.labelKey}`)}
    </Badge>
  );
};
